import * as React from 'react';
import { useSearchBox_unstable } from './useSearchBox';
import { renderSearchBox_unstable } from './renderSearchBox';
import { useSearchBoxStyles_unstable } from './useSearchBoxStyles.styles';
/**
 * SearchBox component - TODO: add more docs
 */
export const SearchBox = /*#__PURE__*/React.forwardRef((props, ref) => {
  const state = useSearchBox_unstable(props, ref);
  useSearchBoxStyles_unstable(state);
  return renderSearchBox_unstable(state);
});
SearchBox.displayName = 'SearchBox';